module.exports = __webpack_public_path__ + "img/order-cover.9c5fe8dc.png";